export default "__VITE_ASSET__BPfVEPjf__"